import { IStep } from '../../../interface/concretes/step.interface';
import { LayoutInfo } from './layout-info.model';

export class Step implements IStep {
  private _layoutInfo: LayoutInfo;
  private _url: string;
  private _isDefault: boolean = false;
  private _isActive: boolean = false;
  private _isCompleted: boolean = false;
  private _isAutomatic: boolean = false;

  constructor(
    layoutInfo: LayoutInfo,
    url: string,
    isDefault: boolean,
    isActive: boolean,
    isCompleted: boolean,
    isAutomatic: boolean,
  ) {
    this._layoutInfo = layoutInfo;
    this._url = url;
    this._isDefault = isDefault;
    this._isActive = isActive;
    this._isCompleted = isCompleted;
    this._isAutomatic = isAutomatic;
  }

  get layoutInfo(): LayoutInfo {
    return this._layoutInfo;
  }

  get url(): string {
    return this._url;
  }

  get isActive(): boolean {
    return this._isActive;
  }

  get isCompleted(): boolean {
    return this._isCompleted;
  }

  get isDefault(): boolean {
    return this._isDefault;
  }

  get isAutomatic(): boolean {
    return this._isAutomatic;
  }

  set layoutInfo(value: LayoutInfo) {
    this._layoutInfo = value;
  }

  set url(value: string) {
    this._url = value;
  }

  set isDefault(value: boolean) {
    this._isDefault = value;
  }

  set isActive(value: boolean) {
    this._isActive = value;
  }

  set isCompleted(value: boolean) {
    this._isCompleted = value;
  }

  set isAutomatic(value: boolean) {
    this._isAutomatic = value;
  }
}
